import React from "react";

let biopicPath = require.context("../../public/images/biopic", true);
let nbiopic = biopicPath("./nilgunbio.jpg");
let nclientpic = biopicPath("./const.jpg");

const About = () => {
	return (
		<main className="page firm-page">
			<div className="site-container">
				<h1 className="page-title">Our Firm</h1>
				<div className="accent-line" />

				<section className="firm-section">
					<div className="firm-text">
						<p>Nilgun A.Wolpe is the president and founder of NY Engineering, a structural engineering company doing business in the San Francisco Bay Area and beyond. She founded the company in 2004. The company’s projects range from commercial, seismic soft story, multi-family, and residential overall. NY Engineering has engineered over 7,000,000 square feet since its inception and has averaged 400,000 to 500,000 square feet annually in recent years. As an engineer, Nilgun Wolpe has 20 years of experience in California, as well as 10 years of experience working abroad for a total of 30 years of engineering experience. She designs steel, wood, concrete, masonry buildings, and also specializes in seismic retrofit for a wide range of building types. Her company provides high- performance execution in all her work with an uncommonly reasonable response time. She prides herself in following her projects from her design phase through to the completed construction and works tirelessly to provide extra details for job site conditions. She will often guide contractors during the construction phase with a very hands-on approach. She enjoys and takes pride in making her projects come alive.</p>
						<p>She also believes in teamwork and in finding cost-effective and unique engineering solutions for each project she undertakes. To this end, she prides herself on staying current with Code changes and constantly attends seminars to maintain her very positive relationships with a wide range of building departments. NY Engineering is the company people come to when they want their project done right the first time, every time.</p>
					</div>
					<img src={nbiopic} alt="Nilgun A. Wolpe" />
				</section>

				<section className="firm-section firm-section-reverse">
					<img src={nclientpic} alt="Construction site" />
					<div className="firm-text">
						<p>We are a structural engineering firm that has been in business since 2004. Our projects encompass a wide range, with the majority being residential and low rise commercial construction. We are a firm sized to allow participation by the principal in virtually all aspects of all projects. Our clients are predominantly architects, developers, design-build contractors, and property owners.</p>
						<p>Our design approach is to have a collaborative effort between the client, architect, and contractors. Our principle is that we want to solve problems that arise, not to create project obstructions. Our goal is to provide an economical solution to designs that push the envelope rather than compromise a design with over-engineering.</p>
						<p>Our firm is known for its attention to detail and careful project management. Our experienced professionals are trained to apply creative and cost-effective solutions. Utilizing top-level teamwork and technical expertise, we try to bring the client a cost- effective and unique solution to their engineering needs. We enjoy the fact that our clients return again and again and we value building these personal relationships. Our engineers are trained to combine the right mixture of technical and practical skills to apply building code requirements with both imagination and engineering judgment rarely combined by others.</p>
						<p>We understand the importance of sound structural design that facilitates construction with high- performance execution. Thus, we never forget to take into account the importance of engineering as a service profession and always provide a reliable product in a reasonable response time.</p>
					</div>
				</section>

				<section className="licenses-section" id="licenses-certifications">
					<h2>Licenses & Certifications</h2>

					<div className="license-group">
						<h3>Education</h3>
						<p><strong>Middle East Technical University, Turkey</strong></p>
						<p>Bachelor of Science in Civil Engineering</p>
					</div>

					<div className="license-group">
						<h3>Licenses</h3>
						<p><strong>Professional Engineer in Civil Engineering</strong></p>
						<p>Board for Professional Engineers and Land Surveyors</p>
						<p>California License #68482</p>
						<br />
						<p><strong>Professional Engineer in the State of New York</strong></p>
						<p>The University of the State of New York</p>
						<p>New York License #101584</p>
					</div>

					<div className="license-group">
						<h3>Certifications</h3>
						<p>GSA Award Engineer</p>
						<p>LBE: Local Business Enterprise</p>
						<p>WBE: Women Business Enterprise</p>
						<p>WOSB: Women-Owned Small Business</p>
						<p>WBENC: Women’s Business Enterprise National Council</p>
					</div>

					<div className="license-group">
						<h3>SEAONC Certificates</h3>
						<p>2025 CBC Updates</p>
						<p>Retrofit of Soft Story Wood Framed Buildings</p>
					</div>

					<div className="license-group">
						<h3>S.K. Ghosh Associates Certificates</h3>
						<p>2024 IEBC</p>
						<p>Structural Changes in the 2024 IBC</p>
						<p>Changes in ASCE/SEI 7-22</p>
						<p>Structural Irregularities in Seismic Design</p>
						<p>Design Load Combinations of the 2024 IBC & ASCE/SEI 7-22</p>
						<p>TMS 402-2016 Masonry Code</p>
						<p>Earthquake / Wind Code Provisions</p>
						<p>Steel Moment Frames</p>
						<p>Wood Shear Wall Seismic & Wind Design</p>
						<p>Significant Wood Design & Construction Changes</p>
					</div>

					<div className="license-group">
						<h3>SIMPSON Strong-Tie Certificates</h3>
						<p>Lateral Systems & Retrofits</p>
						<p>General Construction Review with Lateral Systems & Anchors</p>
					</div>
				</section>
			</div>
		</main>
	);
};

export default About;
